import { useCallback } from 'react';
import { deliveryDateDisabledStatuses } from '../constants';

const useDeliveryDateStatusCheck = () => {
  const deliveryDateStatusCheck = useCallback((status: string) => {
    return deliveryDateDisabledStatuses.includes(status);
  }, []);

  return { deliveryDateStatusCheck };
};

export default useDeliveryDateStatusCheck;
